import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import { StringSelect } from "TaskDialogCommon/StringSelect";
import HeroObjectSelector from "TaskDialogCommon/HeroObjectSelector";
import { getData } from "Utils/Common";
import store from "store";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "worldboss";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        selectedworldboss: "",
        noOfHits: "50",
        poprunemins: "30",
        speedinsecs: "4",
        unboxtroops: true,
        mithhits: "0",
        troops: {},
      },
      activeworldbosses: null,
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = () => {
    const { accountdetailrow } = this.props;
    const dataparams = {
      accountdetail: accountdetailrow,
      datakey: "activeworldbosses",
    };
    store.dispatch({ type: "ISLOADING", payload: true });
    getData(dataparams, ({ data: { ok, data } }) => {
      let activeworldbosses = null;
      if (ok) {
        activeworldbosses = data.activeworldbosses;
        if (!activeworldbosses || activeworldbosses.length === 0) {
          errordialog.showError(
            "No Active World Boss Event detected. Please try when there is one."
          );
        }
      }
      this.setState({ activeworldbosses });
      store.dispatch({ type: "ISLOADING", payload: false });
    }).catch((error) => {
      logger.log(
        "Error",
        error.message,
        error.error && error.error.message,
        error.response
      );
      store.dispatch({ type: "ISLOADING", payload: false });
      errordialog.showError(error.response.data.message);
    });
  };

  validate = () => {
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        for (var key in accountdetail.activeworldbosses) {
          var wbObj = accountdetail.activeworldbosses[key];
          if (wbObj.eventname === storeddata.selectedworldboss.eventname) {
            taskConfig.selectedworldboss = wbObj;
            break;
          }
        }
        taskConfig.noOfHits = storeddata.noOfHits;
        taskConfig.poprunemins = storeddata.poprunemins;
        taskConfig.speedinsecs = storeddata.speedinsecs;
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.mithhits = storeddata.mithhits;
        taskConfig.troops = { ...storeddata.troops };
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  setTaskConfigChanges = (taskConfigChanges, callBack) => {
    this.setState(
      (s, p) => ({
        taskConfig: { ...s.taskConfig, ...taskConfigChanges },
      }),
      callBack
    );
  };

  render = () => {
    const {
      setValue,
      validate,
      setTaskConfigChanges,
      state: { taskConfig, activeworldbosses },
      props: { AccountDetailData },
    } = this;

    if (!activeworldbosses || activeworldbosses.length === 0) {
      return null;
    }

    return (
      <TaskDialog heading={"World Boss"}>
        <StringSelect
          label={"Select World Boss Event To Hit"}
          param={"selectedworldboss"}
          setTaskConfigChanges={setTaskConfigChanges}
          taskConfig={taskConfig}
          optionObject={activeworldbosses}
          labelParser={(k, v) => v.eventname}
          valueParser={(k, v) => v}
        />
        <HeroObjectSelector
          label={"Select Hero"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"selectedhero"}
        />
        <TaskInput
          label={"Auto Pop 200% Runes for mins(Optional)"}
          value={taskConfig.poprunemins}
          onChange={(event) => setValue(event, "poprunemins")}
        />
        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />
        <TaskInput
          label={"Hit Speed in secs"}
          value={taskConfig.speedinsecs}
          onChange={(event) => setValue(event, "speedinsecs")}
        />
        <TaskInput
          label={"No of mith hits to try with unboxed mith(put 999 for max)"}
          value={taskConfig.mithhits}
          onChange={(event) => setValue(event, "mithhits")}
        />
        <TaskInput
          label={"No of hits"}
          value={taskConfig.noOfHits}
          onChange={(event) => setValue(event, "noOfHits")}
        />

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send"}
          param={"troops"}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run WorldBoss"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
